import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { changeLanguage } from '../redux/slices/languageSlice';
import { FormControl, MenuItem, Select, InputLabel } from '@mui/material';

const languages = [
  { code: 'en', label: 'English', flag: '/assets/images/flags/gb.png' },
  { code: 'tr', label: 'Türkçe', flag: '/assets/images/flags/tr.png' },
];

const LanguageSwitcher = ({ displayText = true }) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state) => state.language.lang);

  const handleChange = (event) => {
    const selectedLang = event.target.value;
    dispatch(changeLanguage(selectedLang));
    i18n.changeLanguage(selectedLang);
  };

  const currentLang = languages.find((lang) => lang.code === currentLanguage);

  return (
    <FormControl variant="outlined" size="small" sx={{ minWidth: displayText ? 80 : 40, border: 'none' }}>
      <Select
        value={currentLanguage}
        onChange={handleChange}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': { border: 'none' }, // Border'ı kaldırır
          '& .MuiSelect-select': { display: 'flex', alignItems: 'center' },
        }}
        renderValue={(selected) => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={currentLang?.flag}
              alt={currentLang?.label}
              style={{
                width: 24,
                height: 16,
                marginRight: displayText ? 8 : 0,
              }}
            />
            {displayText && currentLang?.label}
          </div>
        )}
      >
        {languages.map((lang) => (
          <MenuItem key={lang.code} value={lang.code} sx={{ display: 'flex', alignItems: 'center', fontSize: 14 }}>
            <img
              src={lang.flag}
              alt={lang.label}
              style={{
                width: 24, // Bayrak boyutu büyütüldü
                height: 16,
                marginRight: 8,
              }}
            />
            {lang.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSwitcher;
